import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import WebpageListPage from './WebpageList';

const WebpageList = () => {
    const { t } = useTranslation(['webpageList']);
    const { permissions: accountPermissions } = useAccount();
    const addWebpage = useGoTo('/admin/webpages/add');
    const extra = hasPermissions(accountPermissions, [permissionKind.createWebpage]) ? (
        <Button icon={<PlusOutlined />} onClick={addWebpage} type="primary">
            {t('webpageList:actions.addWebpage')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('webpageList:title')}>
            <WebpageListPage />
        </ConsolePageWithHeader>
    );
};

export default WebpageList;
